// frontend/src/components/dashboard/RoleDialog.js
import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControl,
    RadioGroup,
    FormControlLabel,
    Radio,
    Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function RoleDialog({ open, onClose, specialist, onSave }) {
    const { t } = useTranslation();
    const [selectedRole, setSelectedRole] = useState(specialist?.role || 'specialist');

    const handleSave = () => {
        onSave(selectedRole);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                {t('common.changeRole')} - {specialist?.name}
            </DialogTitle>
            <DialogContent>
                <FormControl component="fieldset">
                    <RadioGroup
                        value={selectedRole}
                        onChange={(e) => setSelectedRole(e.target.value)}
                    >
                        <FormControlLabel 
                            value="specialist" 
                            control={<Radio />} 
                            label={t('common.specialist')}
                        />
                        <FormControlLabel 
                            value="admin" 
                            control={<Radio />} 
                            label={t('common.admin')}
                        />
                    </RadioGroup>
                </FormControl>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                    {selectedRole === 'admin' 
                        ? t('common.adminRoleDescription')
                        : t('common.specialistRoleDescription')
                    }
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t('common.cancel')}</Button>
                <Button onClick={handleSave} variant="contained" color="primary">
                    {t('common.savechanges')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}